import * as yup from 'yup';
const emailValidation = yup
    .string()
    .test("email", "Invalid email", function (value) {
        if (!value) return true;
        return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
    })
    .required("Email is required");

export const loginValidation = yup.object({
    email: emailValidation,
    password: yup.string().required('Password is required')
});

export const forgotPasswordValidation = yup.object({
    email: emailValidation,
});

export const resetPasswordValidation = yup.object({
    password: yup.string().required('Password is required'),
    confirmPassword: yup.string().oneOf([yup.ref('password'), null], "Passwords don't match.")
        .required('Password is required').min(6, 'Password should be atleast 6 characters'),
});

export const changePasswordValidation = yup.object({
    oldPassword: yup.string().required('Old password is required'),
    newPassword: yup.string().required('New password is required'),
    confirmPassword: yup.string().oneOf([yup.ref('newPassword'), null], "Passwords don't match.")
        .required('Confirm Password is required'),
});

export const profileValidation = yup.object({
    name: yup.string().required('Name is required'),
    email: emailValidation,
    phone: yup.string().required('Phone is required').min(9).max(14).matches(/^\d+$/, 'Phone number must consist of digits only')
});

export const sendEmailValidation = yup.object({
    subject: yup.string().required('Subject is required'),
    message: yup.string().required('Message is required'),
});


export const ticketValidation = yup.object({
    message: yup.string().required('Message is required'),
})
